import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function Login() {
  const { login, user, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  // If already signed in, skip the form and send them into the suite.
  useEffect(() => {
    if (!loading && user) nav("/dashboard", { replace: true });
  }, [loading, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome back");
      nav("/dashboard");
    } else toast.error(res.error);
  };

  return (
    <div className="vbs-auth-bg" style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
      <div className="vbs-card" style={{ width: "100%", maxWidth: 440, padding: 36 }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
            <span className="vbs-logo-dot" />
            <span style={{ fontFamily: "var(--font-display)", fontSize: 22, fontWeight: 700, color: "var(--white)" }}>
              Viral Book Suite
            </span>
          </div>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 10, letterSpacing: 2, color: "var(--gold-dim)", textTransform: "uppercase" }}>
            Powered By The Book Cot · Sign In
          </div>
        </div>

        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <label style={{ display: "block" }}>
            <div style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--gold-dim)", letterSpacing: 1.5, marginBottom: 6, textTransform: "uppercase" }}>Email</div>
            <input data-testid="login-email" className="vbs-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          </label>
          <label style={{ display: "block" }}>
            <div style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--gold-dim)", letterSpacing: 1.5, marginBottom: 6, textTransform: "uppercase" }}>Password</div>
            <input data-testid="login-password" className="vbs-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </label>
          <button data-testid="login-submit" type="submit" disabled={busy} className="vbs-btn vbs-btn-gold" style={{ padding: 14, marginTop: 6 }}>
            {busy ? "Signing in…" : "Sign In"}
            <Sparkles size={15} />
          </button>
        </form>

        <div style={{ marginTop: 22, textAlign: "center", fontSize: 13, color: "var(--muted)" }}>
          <Link to="/forgot-password" data-testid="forgot-link">Forgot password?</Link>
          <span style={{ margin: "0 10px" }}>·</span>
          <Link to="/signup" data-testid="signup-link">Create account</Link>
        </div>
      </div>
    </div>
  );
}
